// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._18u01b66{margin-left:var(--ds-space-050,4px)}\n._1bsbgktf{width:20px}\n._1bto1l2s{text-overflow:ellipsis}\n._1reo15vq{overflow-x:hidden}\n._1ul9gktf{min-width:20px}\n._4t3igktf{height:20px}", ""]);
// Exports
module.exports = exports;
